import { useEffect } from "react";

// ガイダンスの画面を開いているあいだ、html と body の背景をその画面の背景色にする。
// iPhone の Safari では、画面のいちばん上(ステータスバーの裏など)や引っぱったときに html/body の背景(白)が見え、
// 灰色の画面の上に白い帯が残っていたため。画面を閉じたら元に戻す。
export default function usePageBackground(color: string, active = true) {
  useEffect(() => {
    if (!active) return;
    const html = document.documentElement.style;
    const body = document.body.style;
    const prev = [html.backgroundColor, body.backgroundColor];
    html.backgroundColor = color;
    body.backgroundColor = color;
    return () => {
      html.backgroundColor = prev[0];
      body.backgroundColor = prev[1];
    };
  }, [color, active]);
}
